import { Chat, ChatList, LogFile, LoggerSettings, ModalData, Prompt } from '.';
import { DLPState } from './Enums';
import { PaginationListType } from './PaginationParams';

export interface StoreChat {
    chat: Chat;
    chatMessages: Record<string, any>;
    isSending: boolean;
    isNewChat: boolean;
    chatLoaded: boolean;
    messagesLoaded: boolean;
    prompts: Prompt[];
    websocketError: any;
    isStopable: boolean;
    updateChat: boolean;
    chatContainerStyles: any;
}

export interface StoreSettings {
    systemStatus: 'running' | 'updating';
    dataProtectionText: string;
    demo: boolean;
    betaActive: boolean;
    icapActive: boolean;
    features: {
        documentUpload: boolean;
    };
    sensitivityLabels: string[];
    localGroups: boolean;
    bugreporting: boolean;
    registrationEnabled: boolean;
    version: string;
    apiBaseUrl: string;
    websocketUrl: string;
    oidcConfiurationUrl: string;
    oidcAuthority: string;
    oidcClientId: string;
    oidcUserIdentifier: string;
    oidcLogoutUrl: string;
    changelogs: string[];
    changelogHash: string;
    maxCosts: number;
    licences: number;
    apiKeyLicences: number;
    userStatistic: boolean;
    prePaidNotifications: boolean;
    proxyUrlHttp: string;
    proxyUrlHttps: string;
    proxyExceptions: string;
    proxyCertificatePem: string;
    icapAddress: string;
    summaryModel: string;
    defaultModel: string;
    embeddingModel: string;
    embeddingModelDlp: DLPState;
    dlpRegexes: DlpRegex[];
    dlpEntities: string[];
    availableDlpEntities: Record<string, string>;
    allowList: string[];
    publicVersion: string;
    supportMailAddress: string;
    prePaidActive: boolean;
    selfUpdateActive: boolean;
    licenseKey: string;
    accountId: string;
    releaseChannel: string;
    instanceSystemPrompt: string;
    bestPracticeSystemPrompt: string;
    themeIdentifier: string;
    loggerSettings: LoggerSettings;
    chatDuration: string;
    openaiDocumentProcessingEnabled: boolean;
    reloadSettings: boolean;
    debugMode: boolean;
    allowedProtocols?: string[];
    additionalAllowedProtocols?: string[];
    knowledgebaseSearchMode: 'hybrid' | 'similarity';
}

export interface StoreNavigationHeader {
    navigationTitle: string;
    navigationSubTitle: string;
    isMobileMenuOpen: boolean;
    navigationImage: string;
}

export interface StoreChatlist {
    chatlist: ChatList[];
    chatlistOpen: boolean;
    chatlistOpenHover: boolean;
}

export interface StoreEnvironment {
    basePrompt: Prompt | undefined;
    userPrompts: Prompt[];
    visionPrompt: string;
    selectedPrompt: string;
    showUserStatistics: boolean;
    windowWidth: number;
    windowBreakpoint: number;
    demoInstance: boolean;
    isCtrlOrCmdPressed: boolean;
    currentURL: string;
    currentChatId: string;
    combinedPrompts: Prompt[];
    isDragActive: boolean;
    dragZoneRootProps: any;
    dragZoneInputProps: any;
    sourceContainerState: boolean;
    listReloadType: PaginationListType | null;
    chatlistClear: boolean;
    reloadPrompts: boolean;
}

export interface StoreError {
    error: boolean;
    errorMessage: string;
    status: number;
    errorRedirectCounter: number;
}

export interface StoreI18n {
    i18n: any;
    selectedLanguage: string;
}

export interface StoreJoyride {
    run: boolean;
    stepIndex: number;
    startTour: boolean;
}

export interface StoreModal {
    themeModalState: string;
    demoModalState: string;
    fileDlpModalState: FileDlpModalData;
    modal: ModalData;
}

export enum FileDlpModalDataOrigin {
    Knowledgebase = 'Knowledgebase',
    Chat = 'Chat',
}

export interface FileDlpModalData {
    state: string;
    files: any[];
    origin?: FileDlpModalDataOrigin;
    combinedDlp: DLPState | null;
    callback: any;
}

export interface StoreIncidents {
    incidents: any[];
    hasIncidents: boolean;
}

export interface StoreThemes {
    allThemes: {};
    selectedTheme: string;
    themeSwitcherState: string;
    currentThemeColor: string;
}

export interface StoreMessageSource {
    messageIdentifier: string;
    content: [
        {
            title: string;
            description: string;
            url: string;
        },
    ];
}

export interface DlpRegex {
    label: string;
    regex: string;
}

export interface DlpEntity {
    name: string;
    enabled: boolean;
    label: string;
}

export interface Compliance {
    logFiles: LogFile[];
}
